<template>
  <EmblaCarousel ref="trustpilotСarouselRef" class="trustpilot-carousel">
    <TrustpilotSlideDefault
      v-for="review in reviews"
      :key="review.reviewUrl"
      class="trustpilot-carousel__slide"
      :style="{ width: slideWidth + 'px' }"
      :review="review"
    />
  </EmblaCarousel>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { Review } from './types';
import TrustpilotSlideDefault from '@kano/components/Trustpilot/TrustpilotSlideDefault.vue';
import { initialDataParser } from '@/utilities/initialData';
import EmblaCarousel from '@kano/components/Carousel/EmblaCarousel.vue';
import { templateRef } from '@vueuse/core';
import { default as ResizeObserverPolyfill } from 'resize-observer-polyfill';

const { reviews }: {
  reviews: Review[]
} = initialDataParser(
  'trustpilot',
  ['reviews'],
);

const SLIDE_MIN_WIDTH = 272;
const SLIDE_MAX_WIDTH = 458;

const slideWidth = ref(SLIDE_MIN_WIDTH);
const trustpilotСarouselRef = templateRef('trustpilotСarouselRef');

const calculateSlideWidth = () => {
  const containerWidth = (trustpilotСarouselRef.value?.$el.offsetWidth || window.innerWidth) - 36;
  const calculatedWidth = Math.floor(containerWidth / 4);
  slideWidth.value = Math.min(SLIDE_MAX_WIDTH, Math.max(SLIDE_MIN_WIDTH, calculatedWidth));
};

const ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
const resizeObserver = new ResizeObserver(calculateSlideWidth);

onMounted(() => {
  if (trustpilotСarouselRef.value) {
    resizeObserver.observe(trustpilotСarouselRef.value.$el);
  }
  calculateSlideWidth();
});
</script>

<style scoped lang="scss">
@use '@kanoAssets/styles/breakpoints.scss';

.trustpilot-carousel {
  &__slide {
    margin: 0 6px;
    display: flex;
    flex-direction: column;
    width: 312px;
    min-height: 304px;
    padding: 24px;
    background-color: var(--color-base-4);
    border-radius: 24px;
    flex: 0 0 auto;

    @include breakpoints.desktop {
      width: 458px;
    }
  }

  & ::v-deep {
    & .embla {
      overflow: visible;
      @include breakpoints.desktop {
        overflow: hidden;
      }
    }
  }
}
</style>
